function Map() {
  return (
    <div className="iframe-container">
      <iframe
        src="https://www.google.com/maps?q=York,South+Carolina&output=embed"
        loading="lazy"
        title="Map of York, South Carolina"
      ></iframe>
    </div>
  );
}

export default Map;